
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gaE5c", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9ba9bded8f363683$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $9ba9bded8f363683$export$2e2bcd8739ae039 = {
    'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
    'ai-smart-button.ai-actions.actions.section.text': "\uC791\uC5C5",
    'ai-smart-button.ai-actions.give-feedback-action.title': "\uD53C\uB4DC\uBC31 \uC81C\uCD9C",
    'ai-smart-button.ai-actions.help.section.text': "\uB3C4\uC6C0\uB9D0",
    'ai-smart-button.ai-actions.input.link-picker-button-label': "\uB9C1\uD06C",
    'ai-smart-button.ai-actions.input.mention-button-label': "\uBA58\uC158",
    'ai-smart-button.ai-actions.input.placeholder': "\uD544\uC694\uD55C \uAC83\uC744 \uC785\uB825\uD558\uC138\uC694",
    'ai-smart-button.ai-actions.input.send-button-label': "\uBCF4\uB0B4\uAE30",
    'ai-smart-button.ai-actions.item.betaLozenge': "\uBCA0\uD0C0",
    'ai-smart-button.ai-actions.item.newLozenge': "\uC2E0\uADDC",
    'ai-smart-button.ai-actions.rovo-agents.add-icon-label': "\uC544\uC774\uCF58 \uCD94\uAC00",
    'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': "\uC790\uB3D9\uD654 \uC544\uC774\uCF58",
    'ai-smart-button.ai-actions.rovo-agents.automations.text': "\uC790\uB3D9\uD654",
    'ai-smart-button.ai-actions.rovo-agents.create-agent.text': "\uC5D0\uC774\uC804\uD2B8 \uCC3E\uC544\uBCF4\uAE30",
    'ai-smart-button.ai-actions.rovo-agents.create-automation.text': "\uC790\uB3D9\uD654 \uB9CC\uB4E4\uAE30",
    'ai-smart-button.ai-actions.rovo-agents.section.text': 'Studio',
    'ai-smart-button.ai-dynamic-surface.components.greeting.intro-second-line': "\uBB34\uC5C7\uC744 \uB3C4\uC640\uB4DC\uB9B4\uAE4C\uC694?",
    'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': "{name} \uB2D8, \uC548\uB155\uD558\uC138\uC694.",
    'ai-smart-button.ai-proactive-nudge.dismiss': "\uD574\uC81C",
    'ai-smart-button.feedback-action.ask-question-option': "\uC9C8\uBB38\uD558\uAE30",
    'ai-smart-button.feedback-action.cancel-button-label': "\uCDE8\uC18C",
    'ai-smart-button.feedback-action.choose-feedback-option': "\uD558\uB098 \uC120\uD0DD",
    'ai-smart-button.feedback-action.feedback-entry-bug-heading': "\uBC84\uADF8 \uB610\uB294 \uC774\uC288 \uC124\uBA85",
    'ai-smart-button.feedback-action.feedback-entry-comment-heading': "\uC758\uACAC\uC744 \uC54C\uB824\uC8FC\uC138\uC694",
    'ai-smart-button.feedback-action.feedback-entry-question-heading': "\uBB34\uC5C7\uC744 \uC54C\uACE0 \uC2F6\uC2B5\uB2C8\uAE4C?",
    'ai-smart-button.feedback-action.feedback-entry-suggest-heading': "\uAC1C\uC120\uD558\uAE30 \uC6D0\uD558\uB294 \uB0B4\uC6A9\uC744 \uC54C\uB824\uC8FC\uC138\uC694",
    'ai-smart-button.feedback-action.leave-comment-option': "\uB313\uAE00 \uB0A8\uAE30\uAE30",
    'ai-smart-button.feedback-action.report-bug-option': "\uBC84\uADF8 \uBCF4\uACE0",
    'ai-smart-button.feedback-action.research-participation-message': "\uC81C\uD488 \uC870\uC0AC\uC5D0 \uCC38\uC5EC\uD558\uACE0 \uC2F6\uC2B5\uB2C8\uB2E4",
    'ai-smart-button.feedback-action.select-feedback-heading': "\uC758\uACAC \uC120\uD0DD",
    'ai-smart-button.feedback-action.submit-button-label': "\uD53C\uB4DC\uBC31 \uBCF4\uB0B4\uAE30",
    'ai-smart-button.feedback-action.suggest-improvement-option': "\uAC1C\uC120 \uC0AC\uD56D \uC81C\uC548",
    'ai-smart-button.feedback-action.title': "\uD53C\uB4DC\uBC31 \uC81C\uCD9C",
    'ai-smart-button.feedback-item.icon-label': "\uD53C\uB4DC\uBC31 \uC544\uC774\uCF58",
    'ai-smart-button.reference.close-button-label': "\uB2EB\uAE30",
    'quick-summary.feedback.summary.placeholder': "Atlassian Intelligence\uB294 \uC5B4\uB5A4 \uBD80\uBD84\uC5D0\uC11C \uC791\uC5C5\uC744 \uC798 \uC218\uD589\uD588\uC2B5\uB2C8\uAE4C? \uAC1C\uC120\uD560 \uC810\uC740 \uBB34\uC5C7\uC785\uB2C8\uAE4C?",
    'quick-summary.feedback.title': "Atlassian Intelligence\uB97C \uAC1C\uC120\uD558\uB3C4\uB85D \uB3C4\uC640\uC8FC\uC138\uC694"
};

});


//# sourceMappingURL=ko.43887fdb.js.map
